<script>
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn, DxItem } from 'devextreme-vue/data-grid';
    import modalService from '@/services/core/modal.service';
    import UserAdminModal from '@/components/modals/UserAdminModal';
    import administratorsService from '@/services/administrators.service';

    export default {
        components: {
            AdminGrid,
            DxColumn,
            DxItem
        },
        data() {
            return {
                dataSource: administratorsService.grid()
            };
        },
        methods: {
            onAdd() {
                modalService.show(UserAdminModal, {
                    onSuccess: () => {
                        this.$refs['userGrid'].refresh();
                    }
                });
            },
            onEdit(item) {
                modalService.show(UserAdminModal, {
                    userId: item.id,
                    onSuccess: () => {
                        this.$refs['userGrid'].refresh();
                    }
                });
            },
            onDelete(item) {
                modalService.confirm({
                    title: 'Delete User',
                    msg: `Are you sure you want to delete user ${item.userName}?`,
                    onSuccess: () => {
                        administratorsService.delete(item.id).then(() => {
                            this.$refs['userGrid'].refresh();
                        });
                    }
                });
            }
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi-person-lines-fill"></i>
            Admin Users
        </h3>
    </div>
    <div class="main-content-body">
        <AdminGrid :data-source="dataSource" storage-key="user-list" ref="userGrid">
            <template #toolbar>
                <DxItem location="after" widget="dxButton" :options="{ text: 'Add', onClick: () => onAdd() }" />
            </template>

            <DxColumn data-field="id" />
            <DxColumn data-field="userName" caption="Email" />
            <DxColumn data-field="fullName" caption="Full Name" />

            <template #actions="{ item }">
                <button type="button" class="btn btn-link py-0 lh-1" title="Edit" @click="() => onEdit(item.data)">
                    <i class="bi bi-pencil"></i>
                </button>
                <button type="button" class="btn btn-link py-0 lh-1 text-danger" title="Delete" @click="() => onDelete(item.data)">
                    <i class="bi bi-trash"></i>
                </button>
            </template>
        </AdminGrid>
    </div>
</template>
